import React from "react";
import Image from "next/image";
import { siteConfiguration } from "@/components/shared/sites/sites";

const RedditComponent = ({ translations }: { translations: any }) => {
  return (
    <>
      <div className="mt-2 flex w-full cursor-default select-none flex-col rounded-md border-[0.5px] border-[#3C3C3C] bg-[#2b2d31] p-4 shadow-2xl sm:ml-2">
        <p className="text-xs font-semibold uppercase text-white">
          {siteConfiguration.subredditName}
        </p>
        <Image
          width={500}
          height={500}
          src={"https://cdn6.imgpog.com/reddit.webp"}
          alt="Discord"
          className="mx-auto mt-2 hidden h-14 w-14 rounded-xl sm:block lg:hidden"
          draggable="false"
          loading="eager"
          unoptimized
        />
        <a
          className="mx-auto mb-0 mt-auto w-full lg:mb-auto lg:mt-auto lg:w-auto"
          target="_blank"
          rel="noopener noreferrer"
          href={`https://reddit.com` + siteConfiguration.subredditName}
        >
          <button className="focus-visible:ring-ring ring-offset-background mb-0 mt-2 inline-flex h-10 w-full items-center justify-center whitespace-nowrap rounded-md bg-[#248046] px-4 py-2 text-sm font-medium text-[#e9ffec] transition-colors hover:bg-[#1a6334] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 sm:mt-0 lg:mt-2">
            {translations.joinReddit}
          </button>
        </a>
      </div>
    </>
  );
};

export default RedditComponent;
